module.exports = __webpack_public_path__ + "img/bm-carto-night.94205910.png";